import { View } from 'react-native';

import { MqSwitch, XStack, createMqStyles } from '@fhs/ui';

import { PromoCode, SwitchServiceModeInline } from '../../components';

export function OffersDisclaimer() {
  const mqStyles = useMqStyles();

  return (
    <XStack style={mqStyles.container}>
      <MqSwitch $gteDesktop={() => <PromoCode />} />
      <View style={{ flex: 1 }}>
        <SwitchServiceModeInline />
      </View>
    </XStack>
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      gap: 16,
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 16,
    },
    $gteDesktop: {
      marginTop: 24,
    },
  },
});
